export default __webpack_public_path__ + "static/media/102-light-rain.acd20547.jpeg";